import { Component, Input } from '@angular/core';

import { ApiError, BaseFormList, MessageService } from '../../../core';
import { UsuarioExpedicao } from './usuario-expedicao';
import { usuarioSituacoes } from '../usuario-situacao';

@Component({
    selector: 'sgt-usuario-expedicao',
    templateUrl: './usuario-expedicao.component.html',
    styleUrls: ['./usuario-expedicao.component.less']
})
export class UsuarioExpedicaoComponent implements BaseFormList<UsuarioExpedicao> {
    @Input() entities: UsuarioExpedicao[];
    situacoes = usuarioSituacoes;

    constructor(private messageService: MessageService) { }

    insert() {
        const entity = new UsuarioExpedicao();
        this.entities.push(entity);

        setTimeout(() => jQuery(`#usuarioExpedicaoNome_${this.entities.length - 1}`).focus(), 200)
    }

    delete(index: number) {
        this.messageService.confirm('Deseja realmente excluir esse usuário da expedição?').then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Resolve os usuários da expedição */
    resolve() {
        if (!this.entities) {
            return;
        }

        // Removendo os itens do array que não possuirem o nome informado
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (!entity.nome || entity.nome.trim().length === 0) {
                this.entities.splice(i, 1);
            }
        }
    }
}
